module.exports = __webpack_public_path__ + "static/media/canvas-clear.bd21c1a7.svg";